import { makeVar } from "@apollo/client";

const data = localStorage.getItem("cus-rib-loggedInRole");

const loggedInAsVar = makeVar(data);

export default loggedInAsVar;
